import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals, alert } from 'src/theme/colors';

export const style = StyleSheet.create({
  dropdown: {
    position: 'absolute',
    zIndex: 50,
    left: 24,
    top: 2,
  },
  container: {
    gap: 8,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
  },
  iconClose: {
    color: neutrals.neutralGrays.cement,
    padding: 2,
  },
  title: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
    color: neutrals.black,
  },
  footer: {
    paddingHorizontal: 24,
    alignItems: 'center',
    //height: 48,
  },
  footerWrapper: {
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
    paddingBottom: 24,
  },
  footerText: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
    color: neutrals.neutralGrays.ash,
  },
  footerIcon: {
    width: 24,
    height: 24,
    backgroundColor: alert.alertGreen,
    borderRadius: 12,
    padding: 6,
  },
  addButton: {
    width: '100%',
    marginBottom: 24,
  },
  uploadButton: {
    height: '100%',
    minHeight: 118,
    borderRadius: 20,
    borderWidth: 3,
    borderColor: 'transparent',
  },
  uploadButtonFocus: { borderWidth: 1, borderColor: FOCUS_COLOR },
  button: {
    height: '100%',
    borderRadius: 20,
    padding: 16,
    backgroundColor: neutrals.coldGrays.ice,
    gap: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonIcon: {
    width: 33,
    height: 33,
  },
  buttonText: {
    color: brand.main.water,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 18,
    letterSpacing: 0.16,
    textAlign: 'center',
  },
  textLink: {
    color: brand.main.water,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 17,
    borderWidth: 0,
    borderColor: brand.main.water,
  },
  iconDelete: {
    width: 18,
    height: 18,
    padding: 1,
  },
  subHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingTop: 24,
    height: 30,
  },
  selectedCounter: {
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 15.4,
    letterSpacing: 0,
    color: neutrals.neutralGrays.graphite,
  },
  subHeaderInner: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
  },
  dropzoneText: {
    color: neutrals.neutralGrays.graphite,
    fontSize: 16,
    lineHeight: 22,
    fontWeight: 400,
    textAlign: 'center',
  },
  goToSiteContainer: {
    backgroundColor: '#F3F7F7',
    paddingVertical: 12,
    paddingHorizontal: 24,
    marginBottom: 24,
    borderRadius: 100,
    width: '100%',
  },
  goToSiteInnerContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    gap: 4,
    borderWidth: 0,
    ...getBoxShadow('none'),
    backgroundColor: 'transparent',
    minHeight: 'auto',
    padding: 0,
    margin: 0,
  },
  otherOptionsButton: {
    color: brand.main.water,
    fontSize: 16,
    lineHeight: 20,
    fontWeight: 700,
  },
});
